/**
 * Append a query string to a path (for in-app navigation).
 * e.g. `/booking/70` + `?fbclid=abc` → `/booking/70?fbclid=abc`
 */
export const pathWithSearch = (pathname, search = "") => {
  if (!search) {
    return pathname;
  }
  const query = search.startsWith("?") ? search : `?${search}`;
  return `${pathname}${query}`;
};
